export function setOrderShipFillTable () {
  return [
    {
      title: '订单编号',
      dataIndex: 'code',
      key: 'code',
      width: 160,
      ellipsis: true,
      customRender: (text, row) => {
        const obj = {
          children: text || '--',
          attrs: row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 },
        };
        return obj;
      },
    },
    {
      title: '商品图片',
      dataIndex: 'image',
      key: 'image',
      width: 120,
      ellipsis: true,
      scopedSlots: { customRender: 'imageList' },
    },
    {
      title: '商品编码（sku）',
      dataIndex: 'outSkuCode',
      key: 'outSkuCode',
      width: 150,
      ellipsis: true,
      customRender: (text, row) => {
        return row.dockingSystem === 'XIAOZI_ERP' ? text || '--' : row.skuCode || '--';
      },
    },
    {
      title: '商品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '规格',
      dataIndex: 'specification',
      key: 'specification',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '型号',
      dataIndex: 'model',
      key: 'model',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '所属品牌',
      dataIndex: 'brandName',
      key: 'brandName',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '待发货数量',
      dataIndex: 'unDeliveredQuantity',
      key: 'unDeliveredQuantity',
      width: 160,
      ellipsis: true,
      scopedSlots: { customRender: 'unDeliveredQuantity' },
    },
    {
      title: '是否医疗件',
      dataIndex: 'medicalFlag',
      key: 'medicalFlag',
      width: 110,
      ellipsis: true,
      customRender: text => {
        return text ? '是' : '否';
      },
    },
    {
      title: '物流公司',
      dataIndex: 'logisticsCompanyName',
      key: 'logisticsCompanyName',
      width: 220,
      fixed: 'right',
      ellipsis: true,
      scopedSlots: { customRender: 'logisticsCompanyName' },
      customCell: (row) => {
        return {
          attrs: row.merge ? { rowSpan: row.mergeSpan || 0 } : (row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 }),
        };
      },
    },
    {
      title: '物流单号',
      dataIndex: 'logisticsCode',
      key: 'logisticsCode',
      width: 200,
      fixed: 'right',
      ellipsis: true,
      scopedSlots: { customRender: 'logisticsCode' },
      customCell: (row) => {
        return {
          attrs: row.merge ? { rowSpan: row.mergeSpan || 0 } : (row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 }),
        };
      },
    },
  ];
}
